'use client';

import { c as _c } from "react/compiler-runtime";
import { useQueryClient } from '@tanstack/react-query';
import type { DepartureSubUpdateRequest, DepartureSubUpdateResponse } from '@sola/schema/dotcom/proxy-api/departures.ts';
import type { UserError } from '@sola/shared-utils/errors-user.ts';
import { MUTATION_KEYS, QUERY_KEYS } from '@sola/supporter-sdk/constants.ts';
import { useReadyForQueries, useSupporterMutation } from '@sola/supporter-sdk/hooks/base.ts';
import { commitmentsQuery } from '@sola/supporter-sdk/queries.ts';
import { updateMockDepartureSub } from './mocks.ts';
import type { DepartureSubUnavailableError } from './requests.ts';
import { updateDepartureSub } from './requests.ts';
export const useDepartureSubUpdate = departedChildGlobalId => {
  const $ = _c(15);
  const queryClient = useQueryClient();
  const {
    globalId
  } = useReadyForQueries();
  let t0;
  if ($[0] !== departedChildGlobalId) {
    t0 = [MUTATION_KEYS.departureSubUpdate, departedChildGlobalId];
    $[0] = departedChildGlobalId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== departedChildGlobalId || $[3] !== globalId) {
    t1 = payload => updateDepartureSub(globalId, departedChildGlobalId, payload);
    $[2] = departedChildGlobalId;
    $[3] = globalId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== departedChildGlobalId) {
    t2 = async payload_0 => {
      if (!departedChildGlobalId) {
        throw new Error("Missing departed child global ID.");
      }
      return updateMockDepartureSub(departedChildGlobalId, payload_0);
    };
    $[5] = departedChildGlobalId;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== globalId || $[8] !== queryClient) {
    t3 = res => {
      if (res.departureSummary) {
        queryClient.setQueryData([QUERY_KEYS.supporterDepartureSummary, globalId], res.departureSummary);
      }
      if (!globalId) {
        return;
      }
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.supporterGiftLimits, globalId]
      });
      const queryKey = [QUERY_KEYS.supporterCommitments, globalId];
      queryClient.fetchQuery({
        queryKey,
        queryFn: () => commitmentsQuery.queryFn(globalId, {
          queryClient
        }),
        staleTime: 0
      }).catch(_temp);
    };
    $[7] = globalId;
    $[8] = queryClient;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t0 || $[11] !== t1 || $[12] !== t2 || $[13] !== t3) {
    t4 = {
      mutationKey: t0,
      mutationFn: t1,
      mockMutationFn: t2,
      onSuccess: t3
    };
    $[10] = t0;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return useSupporterMutation(t4);
};
function _temp() {}